// src/utils/phoneTracking.js
//
// Phone taps: one document-level click listener (capture phase, so it also
// sees clicks whose handlers stop propagation) for every tel: link on the site.
// Sends a gtag "phone_click" event, which can be imported into Google Ads as a
// secondary conversion. Google Consent Mode (public/index.html) decides what
// the tag may store; with consent denied it only sends cookieless pings.

let installed = false;

// Staff pages (admin, employee panel): calling a lead from there is not a site conversion
const STAFF_PATH = /^\/(admin|panel|Application|Employees|Settings|login)(\/|$)/;

function onClick(e) {
  const target = e.target;
  const link = target && typeof target.closest === "function" ? target.closest('a[href^="tel:"]') : null;
  if (!link || typeof window.gtag !== "function" || STAFF_PATH.test(window.location.pathname)) return;
  try {
    const href = link.getAttribute("href") || "";
    window.gtag("event", "phone_click", {
      phone_number: href.replace(/\D/g, ""),
      page_path: window.location.pathname,
      link_text: (link.textContent || link.getAttribute("aria-label") || "").replace(/\s+/g, " ").trim().slice(0, 100),
    });
  } catch {
    // never block the call
  }
}

/** Install the listener once (browser only). */
export function installPhoneTracking() {
  if (installed || typeof document === "undefined") return;
  installed = true;
  document.addEventListener("click", onClick, true);
}
